import { SegmentShortApiType } from '@api/types';
import { useState } from 'react';
import { CertificationType } from '@pages/types';
import { Button, colors, IconButton, Row, Space, TextInput } from 'common-components';
import { ItemWithAvatar } from '@components/display';
import { useAppTranslation } from '@hooks';

import { store } from '@/store';

type CreateSegmentCertificationPropsType = {
  certification?: CertificationType
};
const CreateSegmentCertification = ({ certification }: CreateSegmentCertificationPropsType) => {
  const createSegmentCertificationAction = store.use.createSegmentCertificationAction().call;
  const updateSegmentCertificationAction = store.use.updateSegmentCertificationAction().call;
  const deleteSegmentCertificationAction = store.use.deleteSegmentCertificationAction().call;
  const { translate } = useAppTranslation();

  const onRemoveSegment = async (idSegment: string) => {
    deleteSegmentCertificationAction({ idCertification: certification.idCertification, idSegment });
  };

  const onSegmentCreateSubmit = async () => {
    const defaultMinQuality = 90;
    createSegmentCertificationAction({
      icon: certification.icon,
      name: `${certification.name} ${defaultMinQuality}+`,
      qualityMin: defaultMinQuality,
      managers: certification?.managersShort,
      certification: {
        icon: certification.icon,
        idCertification: certification.idCertification,
        name: `${certification.name} ${defaultMinQuality}+`,
      },
    });
  };

  const onSegmentUpdateSubmit = async (
    segment: Partial<SegmentShortApiType>,
    qualityVal: number,
  ) => {
    updateSegmentCertificationAction({
      idSegment: segment.idSegment,
      icon: certification.icon,
      name: `${certification.name} ${qualityVal}+`,
      qualityMin: qualityVal,
      managers: certification?.managersShort,
      certification: {
        icon: certification.icon,
        idCertification: certification.idCertification,
        name: `${certification.name} ${qualityVal}+`,
      },
    });
  };

  const QualityValueInput = ({ segment }: { segment: Partial<SegmentShortApiType> }) => {
    const [val, setVal] = useState(segment.qualityMin || 0);

    return (
      <TextInput
        disabled={!segment.idSegment}
        type={'number'}
        value={val}
        suffix={
          <IconButton
            type={'text'}
            style={{ margin: 0, padding: 0 }}
            onClick={() => onSegmentUpdateSubmit(segment, val)}
            icon={'CheckCircle'}
          />
        }
        onChange={(ev) => setVal(Number(ev.target.value))}
        max={100}
        min={0}
        style={{ width: 320 }}
      />
    );
  };

  return (
    <>
      {certification?.segmentsShort?.map((segment) => (
        <Row
          key={segment.idSegment}
          justify={'space-between'}
          align={'middle'}
          style={{ width: '100%', marginBottom: 8 }}
        >
          <ItemWithAvatar
            title={segment.name}
            titleProps={{ style: { fontSize: 14, lineHeight: '20px', fontWeight: 400, color: colors.gray600 } }}
            containerProps={{ style: {}, align: 'center' }}
          />
          <Space size={16}>
            <QualityValueInput segment={segment} />
            <IconButton type={'text'} onClick={() => onRemoveSegment(segment.idSegment)} icon={'XClose'} />
          </Space>
        </Row>
      ))}
      <Button size="sm" style={{ marginTop: 16 }} onClick={onSegmentCreateSubmit}>
        {translate('certificationCreation.settings.segments.addSegmentButton')}
      </Button>
    </>
  );
};

export default CreateSegmentCertification;
